export default "__VITE_ASSET__4397d952__"